/**
 * Global Quick View - Interactivity
 * Refined for maximum reliability and premium feel.
 */
(function () {
    // RENDER READY - Reveal elements once page is processed to prevent ghosting
    const markReady = () => document.body.classList.add('is-ready');
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', markReady);
    } else {
        markReady();
    }

    const SELECTORS = {
        trigger: '[data-bundle-quick-view-trigger]',
        modal: '#BundleQuickViewModal',
        overlay: '#BundleQuickViewOverlay',
        contentArea: '#BundleQuickViewContent',
        closeBtn: '#BundleQuickViewClose',
        form: '#BundleQuickViewForm',
        mainImg: '.gqv-main-img',
        thumbsCont: '.gqv-thumbs',
        thumbBtn: '.gqv-thumb',
        prevBtn: '.gqv-thumb-nav.prev',
        nextBtn: '.gqv-thumb-nav.next',
        pillBtn: '.gqv-pill-btn',
        addBtn: '.gqv-add-btn',
        price: '.gqv-price-current',
        comparePrice: '.gqv-price-compare',
        sku: '.gqv-sku'
    };

    let currentProductData = null;
    let currentBundleProductId = null;

    // Define open function globally immediately
    let currentInitialQty = 1;
    window.openBundleQuickView = function (handle, bundleProductId, initialVariantId = null, initialQty = 1) {
        if (!handle) return;
        currentInitialQty = parseInt(initialQty || 1);
        currentBundleProductId = bundleProductId;

        const overlay = document.querySelector(SELECTORS.overlay);
        if (overlay && overlay.parentElement !== document.body) {
            document.body.appendChild(overlay);
        }

        const modal = document.querySelector(SELECTORS.modal);
        const contentArea = document.querySelector(SELECTORS.contentArea);

        if (!modal || !overlay || !contentArea) {
            console.error('Quick View: Modal elements not found in DOM.');
            return;
        }

        // Show overlay first
        overlay.style.display = 'flex';
        // Force reflow for opacity transition
        overlay.offsetHeight;

        // State: Loading
        modal.classList.add('is-open');
        overlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        contentArea.innerHTML = '<div style="display:flex;justify-content:center;align-items:center;height:400px;width:100%;"><span class="gqv-spinner"></span></div>';

        fetchProductContent(handle, contentArea, initialVariantId);
    };

    function closeModal() {
        const modal = document.querySelector(SELECTORS.modal);
        const overlay = document.querySelector(SELECTORS.overlay);
        const contentArea = document.querySelector(SELECTORS.contentArea);

        if (modal) modal.classList.remove('is-open');
        if (overlay) overlay.classList.remove('is-open');
        document.body.style.overflow = '';

        setTimeout(() => {
            if (overlay) overlay.style.display = 'none';
            if (contentArea) contentArea.innerHTML = '';
            currentProductData = null;
        }, 300);
    }

    // Delegation for any clicks on trigger or close elements
    document.addEventListener('click', (e) => {
        const trigger = e.target.closest(SELECTORS.trigger);
        if (trigger) {
            e.preventDefault();
            e.stopPropagation();
            const handle = trigger.getAttribute('data-bundle-quick-view-trigger');
            const bundleProductId = trigger.getAttribute('data-bundle-product-id');
            const variantId = trigger.getAttribute('data-bundle-variant-id');
            const qty = trigger.getAttribute('data-bundle-qty') || 1;
            window.openBundleQuickView(handle, bundleProductId, variantId, qty);
            return;
        }

        const closeBtn = e.target.closest(SELECTORS.closeBtn);
        const overlay = e.target.closest(SELECTORS.overlay);
        if (closeBtn || (overlay && e.target === overlay)) {
            closeModal();
        }
    });

    async function fetchProductContent(handle, contentArea, variantId) {
        try {
            let url = `/products/${handle}`;
            const connector = url.includes('?') ? '&' : '?';
            url += `${connector}section_id=bundle-quick-view-content`;
            if (variantId) url += `&variant=${variantId}`;

            const response = await fetch(url);
            if (!response.ok) throw new Error('Network error');
            const text = await response.text();

            // Success
            contentArea.innerHTML = text;
            initInteractiveElements(contentArea);
        } catch (err) {
            console.error('Quick View: Fetch error', err);
            contentArea.innerHTML = '<div style="padding: 60px; text-align: center; color: #64748b;"><h3>Error loading product</h3><p>Please try again or view the product page directly.</p></div>';
        }
    }

    function initInteractiveElements(container) {
        const dataNode = container.querySelector('[data-gqv-product-json]');
        if (dataNode) {
            try { currentProductData = JSON.parse(dataNode.textContent); }
            catch (e) { console.error('Quick View: JSON error'); }
        }

        initGallery(container);
        initVariants(container);
        initQuantity(container);
        initConfirmSelection(container);
    }



    function initGallery(container) {
        const mainImg = container.querySelector(SELECTORS.mainImg);
        const thumbBtns = container.querySelectorAll(SELECTORS.thumbBtn);
        const thumbsCont = container.querySelector(SELECTORS.thumbsCont);
        const prev = container.querySelector(SELECTORS.prevBtn);
        const next = container.querySelector(SELECTORS.nextBtn);

        if (!mainImg) return;

        thumbBtns.forEach(btn => {
            btn.addEventListener('click', () => {
                const src = btn.getAttribute('data-src');
                if (src && mainImg.src !== src) {
                    updateMainImage(mainImg, src);
                }
                thumbBtns.forEach(b => b.classList.remove('is-active'));
                btn.classList.add('is-active');
            });
        });

        if (prev && thumbsCont) prev.addEventListener('click', () => thumbsCont.scrollBy({ top: -200, behavior: 'smooth' }));
        if (next && thumbsCont) next.addEventListener('click', () => thumbsCont.scrollBy({ top: 200, behavior: 'smooth' }));
    }

    // Removed initQuantity and updateAddBtnTotal since bundle quick view handles quantity externally.

    function initVariants(container) {
        const wrappers = container.querySelectorAll('.gqv-option-wrapper');
        const inputId = container.querySelector('input[name="id"]');
        const skuLabel = container.querySelector(SELECTORS.sku + ' span');
        const priceLabel = container.querySelector(SELECTORS.price);
        const compPriceLabel = container.querySelector(SELECTORS.comparePrice);
        const addBtn = container.querySelector(SELECTORS.addBtn);
        const totalSpan = container.querySelector('.gqv-add-total');

        if (!currentProductData || wrappers.length === 0) return;

        function update() {
            // Get all options, defaulting to the current first variant's options
            // but updating them based on what's actually selected in the UI.
            const selected = [...(currentProductData.variants[0].options)];
            let currentColor = null;

            wrappers.forEach(w => {
                const idx = parseInt(w.getAttribute('data-option-index'));
                const active = w.querySelector('.gqv-pill-btn.is-active');
                if (active) {
                    selected[idx] = active.getAttribute('data-value');
                    if (w.querySelector('.is-swatch')) {
                        currentColor = selected[idx];
                    }
                }
            });

            if (currentColor) {
                reorderThumbnails(container, currentColor);
            }

            const variant = currentProductData.variants.find(v => {
                return v.options.every((opt, i) => opt === selected[i]);
            });

            if (variant) {
                const featuredMediaId = variant.featured_media ? variant.featured_media.id : (variant.featured_image ? variant.featured_image.id : null);
                if (currentColor) {
                    reorderThumbnails(container, currentColor, featuredMediaId);
                }
                
                if (inputId) inputId.value = variant.id;
                if (skuLabel) skuLabel.textContent = variant.sku || 'N/A';
                if (priceLabel) priceLabel.textContent = formatMoney(variant.price);

                // Update variant links - FIXED to avoid 404
                const variantUrl = window.location.origin + '/products/' + currentProductData.handle + '?variant=' + variant.id;
                container.querySelectorAll('[data-gqv-variant-link]').forEach(link => {
                    link.href = variantUrl;
                });

                if (addBtn) {
                    addBtn.disabled = !variant.available;
                    const textSpan = addBtn.querySelector('.gqv-add-text');
                    if (textSpan) {
                        textSpan.textContent = variant.available ? 'CONFIRM' : 'Sold Out';
                    }
                    if (totalSpan) {
                        totalSpan.setAttribute('data-base-price', variant.price);
                        totalSpan.textContent = '— ' + formatMoney(variant.price);
                        totalSpan.style.display = variant.available ? 'inline' : 'none';
                    }
                }

                if (compPriceLabel) {
                    if (variant.compare_at_price > variant.price) {
                        compPriceLabel.textContent = formatMoney(variant.compare_at_price);
                        compPriceLabel.style.display = 'inline-block';
                    } else {
                        compPriceLabel.style.display = 'none';
                    }
                }

    // Removed extra addBtn logic block to avoid duplication

                // Update Unit Price (Each)
                updateUnitPrice(container, variant);

                // Update Free Shipping Message
                updateShippingMessage(container, variant);

                // Sync image & scroll
                if (variant.featured_image) {
                    const mediaId = variant.featured_media ? variant.featured_media.id : variant.featured_image.id;
                    let thumb = container.querySelector(`.gqv-thumb[data-id="${mediaId}"]`);

                    // Fallback to URL match if ID fails
                    if (!thumb && variant.featured_image.src) {
                        const baseUrl = variant.featured_image.src.split('?')[0].split('_')[0]; // Aggressive match
                        thumb = Array.from(container.querySelectorAll('.gqv-thumb')).find(t => {
                            const tSrc = t.getAttribute('data-src');
                            return tSrc && tSrc.includes(baseUrl);
                        });
                    }

                    if (thumb) {
                        const thumbSrc = thumb.getAttribute('data-src');
                        const main = container.querySelector(SELECTORS.mainImg);
                        if (thumbSrc && main && main.src !== thumbSrc) {
                            updateMainImage(main, thumbSrc);
                        }
                        container.querySelectorAll('.gqv-thumb').forEach(t => t.classList.remove('is-active'));
                        thumb.classList.add('is-active');

                        // Scroll thumb into view
                        thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
                    }
                }
            } else if (addBtn) {
                addBtn.disabled = true;
                const textSpan = addBtn.querySelector('.gqv-add-text');
                if (textSpan) textSpan.textContent = 'Unavailable';
                if (totalSpan) totalSpan.style.display = 'none';
            }
        }
        wrappers.forEach(w => {
            const btns = w.querySelectorAll('.gqv-pill-btn');
            const valSpan = w.querySelector('.gqv-selected-value');
            btns.forEach(btn => {
                btn.addEventListener('click', () => {
                    btns.forEach(b => b.classList.remove('is-active'));
                    btn.classList.add('is-active');
                    if (valSpan) valSpan.textContent = btn.getAttribute('data-value');
                    update();
                });
            });
        });

        // Initialize state on load
        if (wrappers.length > 0) {
            update();
        }
    }

    function reorderThumbnails(container, colorValue, featuredMediaId) {
        if (!colorValue) return;
        
        const thumbsCont = container.querySelector(SELECTORS.thumbsCont);
        if (!thumbsCont) return;

        const thumbs = Array.from(container.querySelectorAll(SELECTORS.thumbBtn));
        const colorLower = colorValue.toLowerCase().trim();

        // Separate matching and non-matching
        const featured = [];
        const matching = [];
        const nonMatching = [];

        thumbs.forEach(thumb => {
            const id = thumb.getAttribute('data-id');
            const alt = (thumb.getAttribute('data-alt') || '').toLowerCase().trim();
            
            if (featuredMediaId && id == featuredMediaId) {
                featured.push(thumb);
            } else if (alt === colorLower || alt.includes(colorLower)) {
                matching.push(thumb);
            } else {
                nonMatching.push(thumb);
            }
        });

        if (featured.length === 0 && matching.length === 0) return;

        // Move matching to top (appendChild moves existing nodes)
        featured.forEach(t => thumbsCont.appendChild(t));
        matching.forEach(t => thumbsCont.appendChild(t));
        nonMatching.forEach(t => thumbsCont.appendChild(t));
        
        // Scroll to top of thumbnails
        thumbsCont.scrollTo({ top: 0, behavior: 'auto' });
    }

    function updateShippingMessage(container, variant) {
        const msgLabel = container.querySelector('[data-gqv-shipping-msg]');
        const subtitleLabel = container.querySelector('[data-gqv-shipping-subtitle]');
        if (!msgLabel || !variant) return;

        if (variant.price >= 5000) {
            msgLabel.textContent = 'Shipping Included';
            if (subtitleLabel) {
                subtitleLabel.textContent = 'No extra shipping cost';
                subtitleLabel.style.display = 'block';
            }
        } else {
            msgLabel.textContent = 'Free Shipping $50+';
            if (subtitleLabel) {
                subtitleLabel.style.display = 'none';
            }
        }
    }

    function updateUnitPrice(container, variant) {
        const unitLabel = container.querySelector('[data-gqv-unit-each]');
        if (!unitLabel || !variant) return;

        let totalMultiplier = 1.0;
        const options = variant.options || [];

        options.forEach(opt => {
            const val = opt.toLowerCase();
            // Matching patterns from price.liquid: pack, quantity, cantidad, pairs, pares, pcs, box, caja
            if (val.includes('pack') || val.includes('quantity') || val.includes('cantidad') ||
                val.includes('pairs') || val.includes('pares') || val.includes('pcs') ||
                val.includes('box') || val.includes('caja')) {

                const parts = val.split(/[\s-]+/);
                for (let part of parts) {
                    const num = parseFloat(part.trim());
                    if (!isNaN(num) && num > 0) {
                        totalMultiplier *= num;
                        break;
                    }
                }
            }
        });

        if (totalMultiplier > 1) {
            const unitPrice = variant.price / totalMultiplier;
            unitLabel.textContent = formatMoney(unitPrice) + ' each';
            unitLabel.parentElement.style.display = 'block';
        } else {
            unitLabel.textContent = '';
            unitLabel.parentElement.style.display = 'none';
        }
    }

    function formatMoney(cents) {
        return '$' + (cents / 100).toFixed(2);
    }

    function updateMainImage(imgElement, newSrc) {
        if (!imgElement || !newSrc) return;
        
        // If image is already cached, change might be instant. 
        // We add a tiny delay or use classes for transition.
        imgElement.classList.add('is-loading');
        
        const tempImg = new Image();
        tempImg.onload = () => {
            imgElement.src = newSrc;
            imgElement.classList.remove('is-loading');
        };
        tempImg.src = newSrc;
    }

    function initQuantity(container) {
        const qtyInput = container.querySelector('[data-gqv-qty-input]');
        const btns = container.querySelectorAll('[data-qty-change]');
        const totalSpan = container.querySelector('.gqv-add-total');

        if (!qtyInput) return;
        qtyInput.value = currentInitialQty;

        // Update total label on initial load
        if (totalSpan) {
            const basePrice = parseInt(totalSpan.getAttribute('data-base-price')) || 0;
            totalSpan.textContent = '— ' + formatMoney(basePrice * currentInitialQty);
        }

        btns.forEach(btn => {
            btn.addEventListener('click', () => {
                const change = parseInt(btn.getAttribute('data-qty-change'));
                let current = parseInt(qtyInput.value);
                const next = Math.max(1, current + change);
                qtyInput.value = next;

                // Update total label on the fly
                if (totalSpan) {
                    const basePrice = parseInt(totalSpan.getAttribute('data-base-price')) || 0;
                    totalSpan.textContent = '— ' + formatMoney(basePrice * next);
                }
            });
        });
    }

    function initConfirmSelection(container) {
        const form = container.querySelector(SELECTORS.form);
        if (!form) return;

        form.addEventListener('submit', (e) => {
            e.preventDefault();
            const variantInput = form.querySelector('input[name="id"]');
            const qtyInput = form.querySelector('input[name="quantity"]');
            if (!variantInput || !currentBundleProductId) return;

            const variantId = variantInput.value;
            const qty = parseInt(qtyInput?.value || 1);
            const selectedVariant = currentProductData.variants.find(v => v.id == variantId);

            if (!selectedVariant) return;

            // Dispatch event with all needed data
            const event = new CustomEvent('bundle:variantSelected', {
                detail: {
                    bundleProductId: currentBundleProductId,
                    variantId: selectedVariant.id,
                    price: selectedVariant.price,
                    compareAtPrice: selectedVariant.compare_at_price || '',
                    sku: selectedVariant.sku,
                    title: selectedVariant.title,
                    qty: qty,
                    imageUrl: selectedVariant.featured_media ? selectedVariant.featured_media.preview_image.src : null
                }
            });
            document.dispatchEvent(event);

            closeModal();
        });
    }
})();
